import { BrandHeritageContentType } from '../../../types/content';

export function TimePeriodMobile(props: BrandHeritageContentType) {
  const { imageDescription, imageTitle, quote, quotee, src, timePeriod } =
    props;

  return (
    <div className="flex justify-around items-center w-full px-3">
      <div className="flex justify-center items-center w-1/5 font-ChronicleDisplaySemibold relative p-3">
        <p className="border border-black p-3 sm:p-4 text-body sm:text-header5 bg-white">
          {timePeriod}
        </p>
      </div>
      <div className="flex flex-col w-4/5">
        <div className="border w-full border-black p-3 mb-4">
          <img alt="time-period-image" src={src} />
          <div>
            <h6 className="text-body font-MuseoSans100 mt-3">{imageTitle}</h6>
            <p className="text-subtitle font-extralight mb-5">
              {imageDescription}
            </p>
          </div>
        </div>
        <div className="flex flex-col justify-center items-center w-full text-center font-MuseoSans100 text-caption font-extralight p-3 mb-5">
          &quot;{quote}&quot;
          <p className="font-MuseoSans100 text-caption font-extralight">
            {quotee}
          </p>
        </div>
      </div>
    </div>
  );
}

export default TimePeriodMobile;
